<template>
    <div class="sortTable">
        <div :class="sortTableConfig.dashedColor?sortTableConfig.dashedColor:'title'" v-if="sortTableConfig.titleStyle === 'border'">
            <div>{{sortTableConfig.title}}</div>
        </div>
        <div class='defaultTitle' v-if="sortTableConfig.titleStyle === 'default'">
            <div>{{sortTableConfig.title}}</div>
        </div>
        <table>
            <thead>
                <tr>
                    <td v-if="sortTableConfig.ranking">排名</td>
                    <td v-if="sortTableConfig.product">商品</td>
                    <td v-for="(th , thindex) in sortTableConfig.columns" :key="thindex">{{th.title}}</td>
                </tr>
                
            </thead>
            <tbody>
                <tr v-for="(tb , tbindex) in sortTableConfig.data" :key="tbindex" :class="sortTableConfig.dashedColor">
                    <td v-if="sortTableConfig.ranking">no.{{tbindex +1}}</td>
                    <td v-if="sortTableConfig.product" class="tdImg" @mouseover="overStyle(tbindex)" @mouseout="outStyle(tbindex)"><img :src="tb.commodity?tb.commodity.src:''" alt="" v-show="tbindex === row" >{{tb.commodity?tb.commodity.text:''}}</td>
                    <td v-for="(th , thindex) in sortTableConfig.columns" :key="thindex" >{{tb[th.key]}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data(){
        return {
            row:'',
        }
    },
    props:{
        sortTableConfig:{
            type:Object
        }
    },

    mounted(){
        
    },
    methods:{
        overStyle(index){
           this.row = index;
        },
        outStyle(index){
            this.row = '';
        }
    },
}
</script>

<style scoped>
    /* title样式 */
    .sortTable {
        display: inline-block;
    }
    .sortTable .defaultTitle{
        width: 150px;
        margin: 0 auto;
    }
    .sortTable .defaultTitle div {
        font-size: 12px;
        font-weight: 700;
        color: #999999;
        width: 300px;
    }
    .sortTable .title {
        /* display: inline-block; */
        border-left: 3px solid #FD6442;
        border-bottom: 3px solid #FD6442;
        width: 130px;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
        margin-left: 0;
    }
    .sortTable .title div {
        width: 200px;
        font-size: 14px;
        font-weight: 700;
        color: #FD6442;
    }
    /* 表格样式 */
    .sortTable table {
        table-layout:fixed;
        text-align: center;
        color: #999999;
        margin: 0 auto;
        margin-top: 20px;
        
    }
    .sortTable table thead {
        font-weight: 700;
    }
    .sortTable table tbody tr {
        border-bottom: 1px dashed #FD6442;
        height: 30px;
    }
    /* 虚线颜色 以及标题颜色 */
    .sortTable table .green {
        border-bottom: 1px dashed #50D27C;
    }
    .sortTable>.green{
        border-left: 3px solid #50D27C;
        border-bottom: 3px solid #50D27C;
        width: 130px;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
        margin-left: 0;
    }
    .sortTable .green div {
        width: 200px;
        font-size: 14px;
        font-weight: 700;
        color: #50D27C;
    }
    .sortTable table .blue {
        border-bottom: 1px dashed #39B0F9;
    }
    .sortTable>.blue{
        border-left: 3px solid #39B0F9;
        border-bottom: 3px solid #39B0F9;
        width: 130px;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
        margin-left: 0;
    }
    .sortTable .blue div {
        width: 200px;
        font-size: 14px;
        font-weight: 700;
        color: #39B0F9;
    }
    .sortTable table tbody td {
        word-wrap:break-word;
        max-width: 200px;   
        padding: 5px 10px;
    }
    .sortTable table thead td {
        word-wrap:break-word;
        max-width: 200px; 
        padding: 5px 10px;
    }
    /* 表格中图片样式 */
    .sortTable .tdImg {
        position: relative;
    }
    .sortTable .tdImg img {
        position: absolute;
        top: 5px;
        left: 50xp;
        width: 100px;
        height: 100px;
    }
</style>
